import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usersService } from 'api/configuration/users'
import { IUser } from 'interfaces/users'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useNotification } from 'hooks/notifications/useNotification'

interface IProps {
  user: IUser
  refreshView: () => Promise<void>
  close: () => void
}

export const Remove = ({ user, refreshView, close }: IProps) => {
  const { t } = useTranslation()
  const notification = useNotification()
  const prefix =
    'configuration.rolesAndPermissions.users.table.actions.removeAllPermissions.modal'
  const [processing, setProcessing] = useState(false)

  const remove = async () => {
    setProcessing(true)
    try {
      await usersService.removeAllPermissions(user.id)
      notification.success(
        t(`${prefix}.notifications.success`).replace(
          '{userName}',
          `${user.firstName} ${user.lastName}`
        )
      )
      await refreshView()
      close()
    } finally {
      setProcessing(false)
    }
  }

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.title`)}
      isConfirmation={true}
      maxwidth={800}
      maxheight={204}
      close={close}
      actions={
        <ModalButtons
          primaryText={t(`${prefix}.buttons.removePermissions`)}
          primaryAction={remove}
          secondaryText={t(`${prefix}.buttons.cancel`)}
          secondaryAction={close}
          processing={processing}
        />
      }
    >
      <>
        {t(`${prefix}.descriptionPrefix`)}
        <span
          style={{ fontWeight: 'bold' }}
        >{` ${user.firstName} ${user.lastName}. `}</span>
        {t(`${prefix}.descriptionSuffix`)}
        <div>{t(`${prefix}.confirmation`)}</div>
      </>
    </Modal>
  )
}

export default Remove
